import type { Balance } from '@talos/kyoko';
import { useBalancesContext, useObservableValue } from '@talos/kyoko';
import { map, of } from 'rxjs';
import { useGCashDefaultMarketAccount } from './useGCashDefaultMarketAccount';

export function useBalanceByCurrency() {
  const { balancesByMarketAccountCurrency } = useBalancesContext();
  const defaultMarketAccount = useGCashDefaultMarketAccount();

  const balanceByCurrency = useObservableValue(
    () =>
      defaultMarketAccount
        ? balancesByMarketAccountCurrency.pipe(
            map(balancesByMarketAccountCurrency => {
              const balancesByCurrency = balancesByMarketAccountCurrency.get(defaultMarketAccount);
              return balancesByCurrency || new Map<string, Balance>([]); // Ensure we always return a Map
            })
          )
        : of(new Map<string, Balance>()),
    [balancesByMarketAccountCurrency, defaultMarketAccount]
  );
  return balanceByCurrency;
}
